<template>
<div>
    <div v-if="getHeat == undefined || !hasEntries">
        <message type="error" size="s" :text="$t('text.errorMissingData')"></message>
    </div>
    <div v-if="getHeat != undefined && hasEntries">
        <div class="buttonrow">        
            <button v-if="isVertical && hasHeights" @click="setStartHeightMode" class="link-button" :class="{active: startHeightMode}">{{$t('text.setStartHeight')}}</button>
            <button v-if="isVertical" @click="heightManager" class="link-button">{{$t('text.heightManager')}}</button>
            <button v-if="!isVertical" @click="dropStartlist" class="link-button">{{$t('text.drop')}}</button>
            <c-input v-model="hideEliminated" :labelLeft="false" :title="$t('text.showEliminated')" type="checkbox" class="hide-checkbox" :outline="false" :dense="true"></c-input>
        </div>
        <div class="f-row">
            <div class="f-column grid f-grow">  
                <div ref="grid" class="f-column f-grow" @scroll="onScroll">      
                    <div class="head" ref="head">
                        <div class="fixed f-column">
                            <div class="icon start-pos"></div>
                            <div class="icon bib"></div>
                        </div>            
                        <div class="name-label">
                            <div>{{$t('text.name')}}</div>
                            <div>{{$t('text.club')}}</div>
                        </div>          
                        <div class="result-label">
                            <div>{{$t('text.result')}}</div>
                            <div v-if="!isVertical && hasWind">{{$t('text.wind')}}</div>
                        </div>       
                        <div class="rank-label">
                            <div>{{$t('text.rank')}}</div>
                        </div>      
                        <template v-if="!isVertical"> 
                            <div class="result" v-for="n in SelectedHeat.entries[0].results.length" :key="n">
                                <div :class="{'current-try': isCurrentTry(n-1), 'next-try': isNextTry(n-1)}">
                                    <div>{{$t('text.tryShort')}}{{n}}</div>
                                    <div v-if="hasWind">{{$t('text.windShort')}}{{n}}</div>
                                </div>
                            </div>  
                        </template>  
                        <template v-if="isVertical">
                        <div class="result" v-for="(h, n) in SelectedHeat.heights" :key="n">
                            <div :class="{'current-try': isCurrentTry(n),'next-try': isNextTry(n)}">
                                {{h.value.toFixed(2)}}
                                <template v-if="h.jumpOff">*</template>
                                <span v-if="isCurrentTry(n)" ref="cElement"></span>
                            </div>
                        </div>
                        </template>
                    </div>
                    <template v-for="(entrant, eId) in getSortedStartList">
                        <div class="data" :key="entrant.id" :class="{zebra: eId%2==0, eliminated: isEliminated(entrant.results, SelectedResultId) || !entrant.isEnabled || isDisabled(entrant)}" v-if="!(isDisabled(entrant) && !hideEliminated)">
                            <div class="fixed f-column" ref="rowHead">
                                <div>{{entrant.startPos}}</div>
                                <div>{{entrant.bib}}</div>
                            </div>    
                            <div class="f-column name-label" @click="editEntrie(entrant.id)">
                                <div>{{entrant.name}}</div>
                                <div>{{entrant.club}}</div>
                            </div>   
                            <div class="f-column result-label">
                                <div>{{getBestResult(entrant)}}</div>
                                <div v-if="!isVertical && hasWind">{{getBestWind(entrant)}}</div>
                            </div>
                            <div class="f-column rank-label">
                                <div>{{getRank(entrant)}}</div>
                            </div>
                                
                            <div class="f-column result" v-for="(r, i) in entrant.results" :key="i" @click="onResultClicked(entrant.id, i)" :class="{best: isResultBest(entrant, r), current: isResultCurrent(entrant.id, i), editing: isResultEditing(entrant.id, i), 'fix-enabled': isJumpOff(i), next: isResultNext(entrant.id, i)}">
                                <template v-if="!isVertical">
                                    <div>{{formatResult(r)}}</div>
                                    <div v-if="!isVertical && hasWind">&nbsp;{{formatWind(r.wind)}}&nbsp;</div>
                                </template>
                                <template v-if="isVertical">
                                    <div>{{r.highjumpTries}}</div>
                                </template>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div v-if="isEditWith" class="editor" :class="{hide: startHeightMode}">
                <edit-results v-if="mode==='editor' || !isVertical && mode==='height'"></edit-results>
                <height-manager v-if="mode==='height' && isVertical" 
                    class="height-manager" 
                    @heightmanagersaved="onHeightSaved" 
                    @heightmanageraborted="onHeightAborted">
                </height-manager>
                <edit-entrie v-if="mode==='entrie'" @save="editEntryFinished" @abort="editEntryFinished"></edit-entrie>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from 'vuex';
import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import navMut from '../store/mutations/navigation';

import EditResults from './EditResult';
import HeightManager from './HeightManager';
import EditEntrie from './EditEntrie';
import Message from './Message';
import CInput from './CInput'

export default {
    name: "StartList",
    components: {
        EditResults,
        HeightManager,
        EditEntrie,
        Message,
        CInput,
    },
    data: function(){
        return {
            showEventStateHint: false,
            startHeightMode: false,
            window: {
                width: 0,
                height: 0,
            },
            mode: null,
            okEntries: [],
            noEntries: [],            
            hideEliminated: false,            
            ccUpdate: {
                name: "ReceiveHeatGroupRankUpdate",
                method: (data) => {
                    // console.log(data, this.SelectedHeat, (data.id === this.SelectedHeat.id))
                    if(data.id === this.SelectedHeat.id) {
                        this.setNextEntrant(data);
                    }
                }
            },  
        }
    },
    props: {
        slimVersion: {
            type: Boolean,
            default: false
        },
    },
    methods:{
        ...mapActions([
            glAct.SENDHEATGROUP,
            glAct.SENDCURRENTCURSOR,
        ]),
        ...mapMutations([glMut.SETRESULTIDS,
            glMut.UNSETHEATDATA,
            glMut.SETEDITENTRYID,
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT,
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB
        ]),
        onScroll(){
            this.$refs.head.style.top = `${this.$refs.grid.scrollTop + 40}px`;
            this.$refs.head.children[0].style.left = `${this.$refs.grid.scrollLeft}px`;
            this.$refs.rowHead.forEach(rh => rh.style.left = `${this.$refs.grid.scrollLeft}px`);
        },
        onResultClicked(guid, rId){
            this.sortEntries(rId);
            let validEntries = this.okEntries;

            let eId = validEntries.findIndex(x => x.id === guid);
            eId = eId === -1 ? this.SelectedHeat.entries.findIndex(x => x.id === validEntries[0].id) : this.SelectedHeat.entries.findIndex(x => x.id === guid);
            if(this.isVertical && this.startHeightMode) {
                this.setStartHeight(eId, rId);
            }
            else{
                this.editResult(eId, rId, true);
            }
        },        
        setNextEntrant(data){
            var eId = 0;
            var rId = 0;
            if(!!data.nextEntry){
                eId = this.Entries.findIndex(x => x.id == data.nextEntry);
                if(this.isVertical) {
                    rId = this.Entries[eId].results.findIndex(x => x.heightId == data.nextHeight);
                } 
                else {
                    rId = data.nextTry;
                }
            }

            this.SETRESULTIDS({
                eId: null,
                rId: null, 
                src: 'cc',
                nEId: eId,
                nRId: rId,
            });
        },
        editResult(eId, rId, startRoute){
            if(!this.isVertical || this.hasHeights){
                this.SETRESULTIDS({eId:eId, rId:rId, src: 'other'});
                this.mode = 'editor';
                if(!this.isEditWith && startRoute){
                    this.$router.push('editResult/');
                }
                else{                    
                    this.SENDCURRENTCURSOR({eId: this.Entries[this.CEntryId].id, cResultId: this.CResultId, cHeightId: this.Entries[this.CEntryId].results[this.CResultId].heightId})
                }
            }
        },
        heightManager(){
            this.mode = 'height';
            if(!this.isEditWith){
                this.$router.push('heightManager/');
            }
        },
        editEntrie(guid){
            this.mode = 'entrie';
            this.SETEDITENTRYID(this.SelectedHeat.entries.findIndex(x => x.id === guid))
            if(!this.isEditWith){
                this.$router.push('editEntrie/');
            }

        },
        dropStartlist(){
            this.$router.push('drop/');
        },
        setStartHeightMode(){
            this.startHeightMode = !this.startHeightMode;
            if(!this.startHeightMode && (this.Entries[this.CEntryId].results[this.CResultId].highjumpTries || '').includes('-')) {
                this.SETRESULTIDS({eId:this.NEntryId, rId:this.NResultId, src: 'cc', nEId: null, nRId: null});
                this.editResult(this.CEntryId, this.CResultId, false);
            }
        },
        setStartHeight(eId, rId){
            const res = this.getHeat.entries[eId].results;
            const heights = this.getSortedHeights;
            for(var i=0; i<heights.length; i++){
                var index = res.findIndex(x => x.heightId == heights[i].id);
                if(i < rId) {
                    if(res[index].highjumpTries === '')
                        res[index].highjumpTries = '-';
                }
                else if(res[i].highjumpTries === '-'){
                    res[index].highjumpTries = '';
                }
            }
            this.SENDHEATGROUP();
        },
        formatResult(result){
            if(!result) return '';
            switch(result.value) {
                case -2:
                    if(result.highjumpTries !== 'r') {
                        return '-';
                    }
                    return 'r';
                    break;
                case -1:
                    return 'X';
                    break;
                case 0:
                    return '';
                    break;
                default:
                    return result.value.toFixed(2);
            }
        },
        formatWind(val){
            return val!=null ? (val<=0?'':'+') + val.toFixed(1) : ' ';
        },
        getBestResult(e){
            if(e.bestResultId){
                const r = e.results.filter(x => x.id == e.bestResultId)[0];
                return (r && r !== -1 && r.value) ? r.value !== -1 ? r.value.toFixed(2) : '' : '';
            }
            return '';
        },
        getBestWind(e){
            if(e.bestResultId){
                const r = e.results.filter(x => x.id == e.bestResultId)[0];
                return r.wind ? (r.wind<=0?'':'+') + r.wind : '';
            }
            return '';
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        isResultBest(entrant, result){
            if(!entrant || !result) return false;
            return entrant.bestResultId === result.id && result.value != 0;
        },        
        getRank(e){
            const st = {
                4: this.$i18n.t('text.state.can'), 
                5: this.$i18n.t('text.state.dns'),
                6: this.$i18n.t('text.state.dsq')
            };
            return e.state == 2 ? 
                e.withoutEval ? `${this.$i18n.t('text.noRankingShort')}` : 
                    e.rank ? `${e.rank}.` : '' :
                st[e.state];
        },
        isResultCurrent(eGuid, rId){
            return this.CEntryId === this.SelectedHeat.entries.findIndex(x => x.id === eGuid) && this.CResultId == rId;
        },
        isResultNext(eGuid, rId){
            return this.NEntryId === this.SelectedHeat.entries.findIndex(x => x.id === eGuid) && this.NResultId == rId;
        },
        isResultEditing(eGuid, rId){
            return this.SelectedEntrantId == this.SelectedHeat.entries.findIndex(x => x.id === eGuid) && this.SelectedResultId == rId;
        },
        isEliminated(results, rId){
            if(this.getSortedHeights[rId] && this.getSortedHeights[rId].jumpOff) return false;
            const oA = [];
            results.slice(0, rId).forEach(x => {
                oA.push(x.highjumpTries);
            });
            return oA.join('').replace(/-/g,'').slice(-3) === 'XXX' || oA.includes('r');
        },
        isJumpOff(i) {
            return this.SelectedHeat.heights[i] && this.SelectedHeat.heights[i].jumpOff
        },
        onHeightSaved() {
            if(!!this.getSortedHeights && this.getSortedHeights.some(x => x.id == this.CHeightGuid)) {
                this.editResult(this.CEntryId, this.CResultId, false);
            }
            else{
                this.SETRESULTIDS({eId:0, rId:0, src: 'cc', nEId: null, nRId: null});
                this.editResult(0, 0, false);
            }
        },
        onHeightAborted() {
             this.editResult(this.CEntryId, this.CResultId, false);
        },
        setStateNavi(){
            if(this.HeatState < 2){
                this.HIDENAVPOINT([5]);
                this.SHOWNAVPOINT([4]);
            }
            else if(this.HeatState === 2){
                this.HIDENAVPOINT([4]);
                this.SHOWNAVPOINT([5]);
            }
            else if(this.HeatState === 3){                
                this.UNSETHEATDATA();
                this.$router.push('/competition/events/');
            }
        },
        isCurrentTry(tId){
            var ret = tId === this.CResultId;
            if(ret){
                this.$nextTick(() => {
                    if(!!this.$refs.cElement && this.$refs.cElement.length != 0){
                        this.$refs.grid.scrollLeft = this.$refs.cElement[0].offsetLeft - 200;
                    }
                })
            }
            return ret;
        },
        isNextTry(tId){
            return tId === this.NResultId;
        },     
        sortEntries(rId){
            this.okEntries = [];
            this.noEntries = [];

            rId = rId === undefined ? this.SelectedResultId : rId ;
            
            if(this.isVertical){
                this.SelectedHeat.entries.forEach(e => {
                    if((this.getSortedHeights[rId] && !this.SelectedHeat.heights[rId].jumpOff) && (!e.isEnabled || this.isVertical && this.isEliminated(e.results, rId))) {
                        this.noEntries.push(e);
                    }
                    else{
                        this.okEntries.push(e);
                    }
                });
            }
            else{
                let nextDrop = 0;

                this.SelectedHeat.entries.forEach(e => {
                    
                    for(var i=0; i<=rId; i++){
                        if(e.dropStartlist[i] !== undefined && i > nextDrop) {
                            nextDrop = i;
                        }
                    }
                    
                    if(!e.isEnabled || this.isVertical && this.isEliminated(e.results, rid)) {
                        this.noEntries.push(e);
                    }
                    else{
                        this.okEntries.push(e);
                    }
                });

                if(nextDrop <= rId) {
                    this.noEntries = this.noEntries.concat(this.okEntries.filter(e => !e.dropStartlist[nextDrop]));
                    this.okEntries = this.okEntries.filter(e => !!e.dropStartlist[nextDrop])
                }

                this.okEntries = this.okEntries.sort((a, b) => {
                    if (a.dropStartlist[nextDrop] < b.dropStartlist[nextDrop]) return -1;
                    if (a.dropStartlist[nextDrop] > b.dropStartlist[nextDrop]) return 1;
                    return 0;
                })

                this.noEntries = this.noEntries.sort((a, b) => {
                    if (a.dropStartlist[0] < b.dropStartlist[0]) return -1;
                    if (a.dropStartlist[0] > b.dropStartlist[0]) return 1;
                    return 0
                })
            }
        },     
        editEntryFinished(){ 
            this.SETEDITENTRYID(null);         
            this.mode = 'editor'
        },
        isDisabled(e) {
            return this.noEntries.find(x => x.id === e.id) !== undefined;
        },
        prepareStartList(){
            if(this.getHeat.entries.length != 0){
                if(!this.isVertical || this.hasHeights){
                    this.editResult(this.CEntryId, this.CResultId, false);
                }
                else{
                    this.mode = 'height';
                }
            }
            if(this.SelectedHeat.poolMergeAllowed)
                this.SHOWNAVPOINT([6]);
        },          
        registerMethods(){
            this.REGISTERHUB(this.ccUpdate);
        },
        unregisterMethods(){
            this.UNREGISTERHUB(this.ccUpdate);
        },
    },
    computed:{
        ...mapGetters(['ConnectionState', 'SelectedHeat', 'Entries', 'HeatState', 'SelectedEntrantId', 'SelectedResultId', 'CEntryId', 'NEntryId', 'CResultId', 'NResultId', 'CHeightGuid']),
        getHeat(){
            return this.SelectedHeat;
        },
        hasEntries(){
            return this.SelectedHeat.entries.length !== 0;
        },
        getWindowWidth(){
            return this.window.width;
        },
        isEditWith(){
            return this.getWindowWidth >= 920;
        },
        getSortedHeights(){
            return this.getHeat.heights;
        },
        isVertical(){
            return [2, 3].includes(parseInt(this.getHeat.type));
        },
        isEventInProgress(){
            return this.getHeat.state != 1
        },
        isEditMode(){
            return this.startHeightMode || this.editValue;
        },
        hasHeights(){
            return this.getHeat.heights.length != 0;
        },
        hasWind() {
            return this.SelectedHeat.windMeasurement;
        },  
        getSortedStartList(){
            if(this.SelectedHeat != "" && this.hasEntries) {                
                return this.okEntries.concat(this.noEntries);
            }
            return undefined;
        },      
    },
    watch: {
        HeatState() {
            this.setStateNavi();
        },
        SelectedHeat(){
            this.prepareStartList();
        },
        isEditWith(){
            if(this.isEditWith){
                this.HIDENAVPOINT([8]);
            }
            else {
                this.SHOWNAVPOINT([2, 8]);
            }
        },
        getHeat(v){
            if(this.hasEntries)
                this.sortEntries(); 
        },
        Entries(){
            this.sortEntries();
        },        
        ConnectionState(n, o){
            if(n !== 0 && n != o) {
                this.registerMethods();
            }
            else{
                this.unregisterMethods();
            }
        }
    },
    created(){        
        if(this.ConnectionState !== 0){
            this.registerMethods();
        }
    },
    mounted(){    
        if(this.getHeat){
            if(this.hasEntries){
                this.sortEntries(); 
                this.$nextTick(() => {
                    this.prepareStartList();
                });
                
            }
        }     
        this.SHOWNAVPOINT([2, 8]);
        this.setStateNavi(); 
        window.addEventListener('resize', this.handleResize);
        this.handleResize();     
    },
    beforeDestroy(){    
        window.removeEventListener('resize', this.handleResize);    
        this.HIDENAVPOINT([2, 4, 5, 6, 8]);
        this.unregisterMethods();
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .grid {    
        background-color:$prim_bg_color;
        border-bottom: 0px;
        font-weight: bold;
        padding:10px;
        overflow: hidden;  
        max-height: calc(100vh - (2 * #{$height_mid}) - 20px);
        height: calc(100vh - (2 * #{$height_mid}) - 20px);
        
        > div {            
                overflow: auto; 
                position: relative;
                padding-top: 40px;
                padding-left: 40px;
                height: 0px;

            .icon {
                font: normal normal normal 24px/1 "Material Design Icons";
                line-height: 14px;
            }

            .start-pos::after {
                font-size: 14px;
                content:"\F04BC";
            }

            .bib::after {
                font-size: 10px;
                content:"\F0631";
            }

            .head {   
                @extend %f-row;

                position: absolute;
                z-index: 2;
                margin-top:-40px;
                left:0px;
                padding-left:40px;
                > div {
                    @extend %f-column
                }
            }

            .head, .head .fixed{
                background-color: $table-head-color;
                color: $seltec_color;

                .result{

                    > div {       
                        @extend %f-column;

                        height: 100%;
                        width: 100%;
                        align-items: center;
                        justify-content: center;
                        box-sizing: border-box;
                    }
                    .next-try {
                        border: solid 2px $next-result-color;
                    }
                    .current-try {
                        border: solid 2px $blink-dark-dark;
                    }
                }
                
            }

            .data {               
                @extend %f-row;
            }

            .data, .data .fixed {
                background-color: $zebra-dark;
                color: $font-light-color;
                opacity: 1!important;
                z-index: 1;
            }

            .data.eliminated>div {
                opacity: 0.5;
            }

            .data .fix-enabled {
                opacity: 1!important;
            }

            .zebra, .zebra .fixed {
                background-color: $zebra-light;
                color: $font-light-color;
            }
            
            > div.head, > div.data {  
                width: intrinsic;           /* Safari/WebKit uses a non-standard name */
                width: -moz-max-content;    /* Firefox/Gecko */
                width: -webkit-max-content;
                height: $height_default;    
                font-size: 14px;
                box-sizing: border-box;
                align-items: center;   
                min-width: 100%;

                > div > div:nth-of-type(2), div > div > div:nth-of-type(2) {

                font-weight: initial;
                font-size: 10px;
                padding-top: 2px;
                }
            }

            > div:active {
                background-color:$seltec_color;
                cursor: pointer;
            }

            > div:hover {
                cursor: pointer;
            } 
            

            .fixed {
                left:0px;
                min-width:40px;
                height:$height_default - 1px;
                position: absolute;
                background-color: $prim_bg_color;
                border-right: 1px solid $seltec_color;
                align-items: center;
                justify-content: center;
                // margin-left: -40px;
                + div {
                    padding-left: 10px;
                }
            }

            .name-label {
                width:195px;
                min-width:195px;
            }

            .result-label {
                width:80px;
                min-width:80px;
                height: 100%;            
                align-items: center;
                justify-content: center;
            }

            .rank-label {
                width:70px;
                min-width:70px;
                border-right: 1px solid $seltec_color;
                height: 100%;            
                align-items: center;
                justify-content: center;
            }

            .result {
                display:flex;
                align-items: center;
                justify-content: center;
                width:45px;
                min-width:45px;
                border-right: 1px dotted $sec_bg_color;
                height: 100%;
                box-sizing: border-box;

                
            }

            .result.best {
                background-color: $seltec_color;
                color: $font-dark-color;
            }

            .result.next {
                border: solid 2px $next-result-color;
                background-color:$next-result-bg-color;
                color: $font-dark-color;
            }

            .result.current {
                color: $font-light-color;
                animation: pulse 2s infinite alternate;
            }

            .result.editing {
                border: solid 2px $prim_hint_color;
            }

            // > div div:nth-child(2) {
            //     font-weight: initial;
            //     font-size: 10px;
            //     padding-top: 2px;
            // }
        }
    }

    .editor {
        min-width: 320px;
        width: 320px;
        overflow-x: auto;
        max-height: calc(100vh - (2 * #{$height_mid}) - 10px);
        height: calc(100vh - (2 * #{$height_mid}) - 10px);

        .height-manager {
            padding-top:10px;
            padding-right: 10px;
            max-height: calc(100% - 10px);
            height: calc(100% - 10px);
        }
    }

    .editor.hide {
        min-width: 0px;
        width: 0px;
    }

    .buttonrow {
        @extend %f-row;
        padding:10px;
        padding-bottom:0px;

        .hide-checkbox {
            margin-left: 10px;
        }
    }

    .link-button {
        outline: none;
        height: 40px;
        font-weight: bold;
        font-size: 14px;
        border: solid 2px $seltec_color;
        cursor: pointer;
        background-color: transparent;
        color: #fff;
        margin-left: 10px;
    }

    .link-button:first-of-type {
        margin-left:0px;
    }

    

    button:active {
        background-color: $sec_color_dark;
    }

    button.active {
        background-color: $seltec_color;
        color: $font-dark-color;
    }

    @media screen and (max-width: $body_max_width) {       
        .grid {
            border:0px;
        }
    }

    @keyframes pulse {
        0% {
            background-color: $blink-dark-light;
        }

        100% {
            background-color: $blink-dark-dark;
        }
    }


    

</style>